import type { Form } from '@adornis/forms/form.js';
import { stateful, useState } from '@adornis/functional-lit/stateful.js';
import { html, nothing } from 'lit';
import { repeat } from 'lit/directives/repeat.js';
import { SgIndexedDBFileInput } from '../../../client/components/sg-indexeddb-file-input.js';
import { RegisterMode } from '../../registrationMode.js';
import type { RegisterStudentData } from '../api/registerStudentWithSuSForm.js';

export const SgSusEntryFormFiles = stateful((props: { form: Form<RegisterStudentData>; mode: RegisterMode }) => {
  const [manualUpdateForm, setManualUpdateForm] = useState(0);

  const manualUpdate = () => setManualUpdateForm(manualUpdateForm + 1);

  return html`
    <div class="flex flex-col gap-4 w-full">
      <div class="card w-full">
        <div class="card-body gap-5 p-4 sm:p-6">
          ${
            props.mode !== RegisterMode.REGISTRATION_NEW_ELEMENTARY
              ? html`
                  <div class="flex flex-col gap-4">
                    ${
                      props.mode === RegisterMode.REGISTRATION_ELEMENTARY_HIGH ||
                      props.mode === RegisterMode.REGISTRATION_ELEMENTARY_ELEMENTARY
                        ? html`
                            <h2 class="font-semibold md:text-lg">Zeugnisse der Grundschule</h2>
                            <p>Bitte laden Sie alle bisherigen Zeugnisse hoch.</p>
                          `
                        : html`
                            <h2 class="font-semibold md:text-lg">Bisherige Zeugnisse</h2>
                            <p>Bitte laden Sie die letzten beiden Zeugnisse hoch.</p>
                          `
                    }
                    ${repeat(
                      props.form.document?.files.primarySchoolTranscripts ?? [],
                      (_file, index) => index,
                      (file, index) => html`
                        <div class="flex min-w-0 flex-col gap-3 sm:flex-row sm:items-end">
                          ${SgIndexedDBFileInput({
                            placeholder: 'Zeugnis',
                            value: props.form.document?.files.primarySchoolTranscripts[index],
                            onValueChange: fileId => {
                              const newArray = [...(props.form.document?.files.primarySchoolTranscripts ?? [])];
                              newArray[index] = fileId || '';
                              props.form.pickValueForField(['files', 'primarySchoolTranscripts'], newArray);
                              manualUpdate();
                            },
                          })}
                          ${
                            index >= 1
                              ? html`
                                  <button
                                    type="button"
                                    class="btn btn-ghost btn-square shrink-0"
                                    aria-label="Zeugnisfeld entfernen"
                                    @click=${() => {
                                      const newArray = props.form.document?.files.primarySchoolTranscripts.filter(
                                        (file, i) => i !== index,
                                      );
                                      props.form.pickValueForField(['files', 'primarySchoolTranscripts'], newArray);
                                      manualUpdate();
                                    }}
                                  >
                                    <span
                                      class="icon-[material-symbols--delete-outline-rounded] text-xl"
                                      aria-hidden="true"
                                    ></span>
                                  </button>
                                `
                              : nothing
                          }
                        </div>
                      `,
                    )}

                    <button
                      type="button"
                      class="btn btn-outline h-auto min-h-11 w-full whitespace-normal"
                      @click=${() => {
                        const newArray = [...(props.form.document?.files.primarySchoolTranscripts ?? []), ''];
                        props.form.pickValueForField(['files', 'primarySchoolTranscripts'], newArray);
                        manualUpdate();
                      }}
                    >
                      <span class="icon-[material-symbols--add-rounded] text-xl" aria-hidden="true"></span>
                      Weitere Zeugnisse hinzufügen
                    </button>
                  </div>
                `
              : nothing
          }

          <div class="flex flex-col gap-4">
            <h2 class="font-semibold md:text-lg">Sonstige Dokumente</h2>
            <div class="flex flex-col gap-4">
              ${SgIndexedDBFileInput({
                placeholder: 'Eventuelle diagnostizierte Lernschwächen',
                value: props.form.document?.files.learningDisabilities,
                onValueChange: fileId => {
                  props.form.pickValueForField(['files', 'learningDisabilities'], fileId);
                  manualUpdate();
                },
              })}
              ${SgIndexedDBFileInput({
                placeholder: 'Eventuelles Sorgerechtsurteil',
                value: props.form.document?.files.sorgerechtsurteil,
                onValueChange: fileId => {
                  props.form.pickValueForField(['files', 'sorgerechtsurteil'], fileId);
                  manualUpdate();
                },
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  `;
});
